import "./styles/main.css";
import "@gouvfr/dsfr/dist/dsfr.min.css";
import "@gouvfr/dsfr/dist/dsfr.module.min.js";
import "@gouvfr/dsfr/dist/utility/icons/icons.css";

import { createHead } from "@unhead/vue";
import { marked } from "marked";
import { createPinia } from "pinia";
import { createApp } from "vue";

import App from "./App.vue";
// @ts-expect-error the matomo plugin is a js file without type declarations
import Matomo from "./matomo.js";
import router from "./router";

// markdown configuration
{
  const renderer = {
    link(href: string, title: string, text: string) {
      if (href.startsWith("#")) {
        return `<a
          href="https://accessibilite.numerique.gouv.fr/methode/glossaire/${href}"
          target="_blank"
          class="no-external-icon"
        >
          ${text}
          <span class="fr-sr-only"> (ouvre dans une nouvelle fenêtre)</span>
        </a>`;
      } else {
        return `<a href="${href}">${text}</a>`;
      }
    }
  };

  marked.use({ renderer });
}

const pinia = createPinia();
const head = createHead();

const app = createApp(App);
app.use(router).use(pinia).use(head);

if (import.meta.env.VITE_MATOMO_ENABLE) {
  app.use(Matomo, {
    host: "https://stats.data.gouv.fr",
    siteId: 269,
    router,
    enableLinkTracking: false
  });
}

// setup Sentry error logging
if (import.meta.env.VITE_SENTRY_DSN) {
  Promise.all([
    import("@sentry/vue"),
    import("@sentry/tracing")
  ]).then(([Sentry, { BrowserTracing }]) => {
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      integrations: [
        new BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
          tracePropagationTargets: [window.location.hostname, /^\//]
        }),
        new Sentry.Replay({
          maskAllText: true,
          maskAllInputs: true,
          blockAllMedia: true
        })
      ],
      tracesSampleRate: 0,
      replaysOnErrorSampleRate:
        import.meta.env.VITE_SENTRY_ENVIRONMENT === "production" ? 1 : 0,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? "unknown",
      release: import.meta.env.VITE_SENTRY_RELEASE
    });
  });
}

app.mount("#app");
